export default {
  main: {
    site_id: 18760944,
    enableWorldCup: true,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    terminalId: 992,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    restrictedAdminPrintableTicketsCount: 5,
    timeFormat: "HH:mm",
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    websitePasswordHash: "0281d36d2ff55947cc7bc3a18df07d7d7b0367d370cce141add43095cb1f0179",
    logoSize: "big",
    termsAndConditions: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "Eng",
        order: 1,
      },
      por: {
        short: "PT",
        name: "Por",
        region: "UnitedKingdom",
        order: 5,
      },
    },
  },
  env: {
    lang: "por",
  },
  betslip: {
    "@replace": true,
    enableBookingBet: true,
    enableExpressBonus: true,
    bookingBetBalanceMaxLimit: 9999999,
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
      icon: 'circle',
    },
    {
      url: "betting/prematch",
      name: "Sports",
      enabled: true,
      type: "sportsBook",
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },

    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18760944, tid: 35385, token: "vnX0GQ==", currency: "AOA" }
};
